/** @jsxImportSource @emotion/react */
import React from 'react';
import ProgressSection from './ProgressSection';
import { IProgressItem } from '../IProgressItem';
import MikeTopbarDropdown from '../../mike-topbar-dropdown';

interface IProps extends React.HTMLAttributes<HTMLElement> {
  progressItems: Array<IProgressItem>;
  onClickItemButton?: (id: string) => void;
}

function SpinnersDropdown(props: IProps) {
  const { progressItems, onClickItemButton } = props;
  return (
    <MikeTopbarDropdown>
      {progressItems.map((item, i) => (
        <ProgressSection key={i} title={item.title} progressItem={item} onClickItemButton={onClickItemButton} />
      ))}
    </MikeTopbarDropdown>
  );
}

export default SpinnersDropdown;
